import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import * as _ from 'lodash'
import { Slider } from 'wix-style-react'
import { LIGHT_GRAY } from 'components/styles'
import Text from 'components/common/Text'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 80px;
  margin-top: 10px;
`
const NameContainer = styled.div`
  display: flex;
  width: 150px;
  height: 30px;
  align-items: center;
  justify-content: space-between;
`
const ResetTextContainer = styled.div`
  margin-left: 30px;
  cursor: pointer;
`
const SliderContainer = styled.div`
  width: 300px;
  position: relative;
  top: -0.35em;
`
const SliderLabelLeft = styled.div`
  font-size: 12px;
  color: ${LIGHT_GRAY};
`

class SPDarkenLighten extends Component {

  constructor (props) {
    super(props)
    this.state = {
      value: (props.currentValue.value) ? props.currentValue.value : 0
    }
    this.debouncedOnChange = _.throttle(props.onChange, 300)
  }

  onChange = (data) => {
    // console.log('onChange', data)
    const v = data[0]
    if (v !== this.state.value) {
      this.setState({
        value: v
      })
      this.debouncedOnChange({value: v})
    }
  }

  onReset = () => {
    this.props.onChange({})
    this.setState({
      value: 0
    })
  }

  render () {
    const { title } = this.props
    return (
      <Container>
        <NameContainer>
          <Text size='medium'>{title}</Text>
        </NameContainer>

        <SliderContainer>
          <SliderLabelLeft>Darker</SliderLabelLeft>
          <Slider
            min={-1.0}
            max={1.0}
            step={0.05}
            value={[this.state.value]}
            onChange={this.onChange}
          />
        </SliderContainer>

        <ResetTextContainer
          onClick={this.onReset}
        >
          <Text size='medium'>RESET</Text>
        </ResetTextContainer>
      </Container>
    )
  }
}

SPDarkenLighten.defaultProps = {
  currentValue: {},
  onChange: () => null,
  title: ''
}

SPDarkenLighten.propTypes = {
  currentValue: PropTypes.object,
  onChange: PropTypes.func,
  title: PropTypes.string
}

export default SPDarkenLighten



// WEBPACK FOOTER //
// ./src/components/editor/popovers/customCSS/stylePresetComponents/SPDarkenLighten.js